import { Navigate } from 'react-router';
import { OmsIcon } from '@hf/designSystem/v1';
import type { SpaDefinition } from '@core/routes';
import { FEATURE_FLAG_KEYS } from '@core/utils/flags';
import { OmsGate } from './layout/OmsGate';
import { OmsLayout } from './layout/OmsLayout';

function OmsRoute() {
  return null;
}

function OmsShell() {
  return (
    <OmsGate>
      <OmsLayout />
    </OmsGate>
  );
}

export const omsSpa = {
  key: 'oms',
  path: '/oms',
  label: 'OMS',
  icon: <OmsIcon />,
  public: false,
  nav: 'main',
  trackRecent: true,
  featureFlag: FEATURE_FLAG_KEYS.oms,
  paths: {
    create: 'create',
    pretrade: 'pretrade',
    monitor: 'monitor',
    postTrade: 'post-trade',
    blotter: 'blotter',
    custom: 'custom',
  },
  layout: <OmsShell />,
  children: [
    { index: true, element: <Navigate to="create" replace /> },
    { path: 'create', element: <OmsRoute /> },
    { path: 'pretrade', element: <OmsRoute /> },
    { path: 'monitor', element: <OmsRoute /> },
    { path: 'post-trade', element: <OmsRoute /> },
    { path: 'blotter', element: <OmsRoute /> },
    { path: 'custom', element: <OmsRoute /> },
  ],
} as const satisfies SpaDefinition;
